<div class="row">
  <div class="col-12 col-lg-3 border-lg-right border-primary pe-0">
    <div class="me-lg-n1 bg-white">
      <p *ngIf="booking.details.participants.numberSleepOver">
        {{ 'general.numberOf' | translate }}
        {{ 'bookingModule.sleepingOver' | translate }}:<span
          class="badge bg-soft-primary rounded-pill ms-2"
          >{{ booking.details.participants.numberSleepOver }}</span
        >
      </p>
    </div>
    <ul
      class="nav nav-tabs date-list align-items-center gap-2 justify-content-between"
    >
      <li class="nav-item">
        <add-date-btn
          [text]="'bookingModule.addDateBefore' | translate"
          (onClick)="addDateBefore()"
        ></add-date-btn>
      </li>
      <list-date-li-btn
        class="nav-item"
        *ngFor="let date of datesList; index as dateIndex"
        [date]="date"
        [index]="dateIndex"
        [selectedDate]="selectedDate"
        [isFormValid]="
          getDatesForm(datesList[dateIndex])?.value | isAnyProductSelected
        "
        [selectedLanguage]="configurationService.selectedLang$ | async"
        (onDateClicked)="onDateClick($event, dateIndex)"
        (onDateRemoved)="removeDate($event)"
        [errorMessage]="
          (getDatesForm(datesList[dateIndex])?.value | isAnyProductSelected)
            ? ''
            : ('bookingModule.selectProduct' | translate)
        "
      ></list-date-li-btn>
      <li class="nav-item">
        <add-date-btn
          (onClick)="addDateAfter()"
          [text]="'bookingModule.addDateAfter' | translate"
        ></add-date-btn>
      </li>
    </ul>
  </div>

  <div class="col-md">
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmitFormValues($event)"
      [patchForm]="bookingCatering"
    >
      <div class="" *ngFor="let _ of datesForm?.controls; index as dateIndex">
        <form
          [formGroup]="getDatesForm(datesList[dateIndex])"
          [hidden]="selectedDate !== datesList[dateIndex]"
        >
          <h2 class="my-3">
            {{
              datesList[dateIndex]
                | dateFromMoment
                | date
                  : 'EEE, d MMM yyyy'
                  : undefined
                  : (configurationService.selectedLang$ | async)
            }}
          </h2>

          <button
            *ngIf="dateIndex !== 0"
            class="btn btn-soft-primary btn-sm mb-3"
            type="button"
            [disabled]="dateIndex === 0"
            (click)="copyFromLastDay(dateIndex)"
          >
            <i role="img" class="fa fa-clone" aria-hidden="true"></i>
            <span> {{ 'bookingModule.copyFromPreviousDay' | translate }}</span>
          </button>

          <div *ngIf="productEntities$ | async as productEntities">
            <!-- header -->
            <div class="row gx-2 mb-2 align-items-center">
              <div class="col"></div>
              <small class="col-6 col-md text-end">{{
                'bookingModule.pricePerPerson' | translate
              }}</small>
              <small class="col-2 d-none d-md-block">{{
                'shopModule.quantity' | translate
              }}</small>
              <small class="col-3 d-none d-md-block">{{
                'bookingModule.time' | translate
              }}</small>
              <small class="col-3 d-none d-md-block">{{
                'productModule.resource' | translate
              }}</small>
            </div>
            <!-- end header -->
            <div class="list-group">
              <!-- products list -->

              <div
                *ngFor="let product of products"
                [formGroup]="getProductForm(product.id, datesList[dateIndex])"
                [ngClass]="{
                  'bg-primary-soft':
                    getProductForm(product.id, datesList[dateIndex]).controls
                      .selected?.value === true
                }"
                class="list-group-item"
              >
                <div class="row gx-2 align-items-center">
                  <div class="col-6 col-md mb-3 mb-md-0">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="product{{ product.id }} - {{ dateIndex }}"
                        formControlName="selected"
                        data-test-id="step-4-row-checkbox"
                      />
                      <label
                        class="custom-form-label row gx-2 align-items-center"
                        for="product{{ product.id }} - {{ dateIndex }}"
                      >
                        <strong>{{ product.description }}</strong>
                      </label>
                    </div>
                  </div>
                  <div class="col-4 col-md-1 mb-3 mb-md-0">
                    {{
                      bookingMultiDayService.getProductPrice(
                        product,
                        booking?.details?.targetGroup
                      ) | currency
                    }}
                  </div>
                  <div class="col-3 col-md-2">
                    <small class="d-md-none">{{
                      'shopModule.quantity' | translate
                    }}</small>
                    <input
                      class="form-control"
                      formControlName="qty"
                      data-test-id="step-4-row-qty"
                      [attr.aria-invalid]="
                        getProductForm(product.id, datesList[dateIndex]).get(
                          'qty'
                        )?.invalid &&
                        getProductForm(product.id, datesList[dateIndex]).get(
                          'qty'
                        )?.dirty
                          ? 'true'
                          : null
                      "
                    />
                  </div>
                  <div class="col-3 col-md-3">
                    <small class="d-md-none">{{
                      'bookingModule.time' | translate
                    }}</small>
                    <nz-time-picker
                      type="number"
                      style="width: 100%"
                      formControlName="time"
                      id="time"
                      nzFormat="HH:mm"
                      nzMinuteStep="15"
                      nzSize="large"
                      data-test-id="time"
                      [nzDisabledHours]="disabledHours"
                      [nzDisabledMinutes]="disabledMinutes"
                    ></nz-time-picker>
                  </div>
                  <div class="col-3 col-md-3">
                    <small class="d-md-none">
                      {{ 'productModule.resource' | translate }}
                    </small>
                    <select
                      formControlName="bookableProductId"
                      class="form-select"
                    >
                      <option
                        *ngFor="
                          let bookableProduct of getParentBookableProducts(
                            product
                          ) | async
                        "
                        [value]="bookableProduct.id"
                      >
                        {{ bookableProduct.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- this button should be moved next to continue button-->
            <!-- <button
              class="btn"
              type="button"
              [ngClass]="wholeStayStatus ? 'btn-success' : 'btn-soft-primary'"
              (click)="setForWholeStay(dateIndex)"
            >
              {{ 'bookingModule.useSameArrangement' | translate }}
              <i
                class="fa me-2"
                [ngClass]="wholeStayStatus ? 'fa-check-circle' : 'fa-question'"
              ></i>
            </button> -->
          </div>
        </form>
      </div>
      <div class="row gx-2 mt-5">
        <div class="col-md-auto mb-3 mb-md-0">
          <button
            class="btn"
            type="button"
            (click)="setForWholeStay(selectedDateIndex)"
            [ngClass]="wholeStayStatus ? 'btn-success' : 'btn-soft-primary'"
          >
            {{ 'bookingModule.useSameArrangement' | translate }}
            <i
              class="fa me-2"
              [ngClass]="wholeStayStatus ? 'fa-check-circle' : 'fa-question'"
              role="img"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <p *ngIf="loading">{{ 'general.processing' | translate }}</p>
        <div class="col-md">
          <ng-container>
            <button
              data-test-id="finish-sale-item-partial-mde-flow"
              type="submit"
              class="btn btn-primary w-100"
              [hidden]="(isLoading$ | async) && !loading"
              [disabled]="loading"
            >
              {{ 'general.submit' | translate }}
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                *ngIf="loading || (isLoading$ | async)"
                attr.aria-label="{{ 'general.loading' | translate }}"
              >
              </span>
            </button>
          </ng-container>
          <div
            class="spinner-border"
            role="status"
            [hidden]="!(isLoading$ | async)"
          >
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
